var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "m-0", attrs: { "data-comp": "UiCompletionLine" } },
    [
      _c("i", {
        class: ["fa fa-fw", _vm.bulletClasses],
        attrs: { "data-part": "bullet", "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c(
        "span",
        { class: _vm.labelClasses, attrs: { "data-part": "label" } },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }